import { Map3dMaterial } from "./materials.map";
export class WebMapMaterial extends Map3dMaterial {
    constructor(name, scene) {
        super(name, scene, WebMapMaterial.ShaderName);
    }
    getClassName() {
        return WebMapMaterial.ClassName;
    }
}
WebMapMaterial.ClassName = "WebMapMaterial";
WebMapMaterial.ShaderName = "webmap";
//# sourceMappingURL=materials.webMap.js.map